// src/LogIn.js
import { Component } from 'react';
import { properties } from './properties.js';
import Cookies from 'js-cookie';
import { withTranslation } from 'react-i18next';
import { apiPublicRequest, apiSecuredRequest, cargarIdiomaPreferido} from './functions.js';
import NavBar from './LogInNavBar.js';
import Footer from './Footer.js';
import i18n from './I18N/I18n.js'; 
import './css/login.css';




class LogIn extends Component {

  async componentDidMount() {
    // Verifica que la cookie existe y tiene un valor válido
    await cargarIdiomaPreferido(this.cambiarIdioma);
  }
  

  cambiarIdioma = (idioma, cookie) => {
    const { i18n } = this.props;
    i18n.changeLanguage(idioma); 
    this.forceUpdate();
    Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
  };
  
  _logIn = async (nombre, password) => {
    let data = JSON.stringify({
      "email": `${nombre}`,
      "password": `${password}`,
    });

    try {

      const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);
    

      if (bearerToken.status === 200) {
        let userMail = JSON.stringify({
          email: `${nombre}`,
        });
        const userData = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/usuario/getUser`, userMail, bearerToken.data.accessToken);
        const usuario = userData.data;
        Cookies.set('email', usuario.email);
        Cookies.set('rol', usuario.rol);
        Cookies.set('id', bearerToken.data.accessToken);
        Cookies.set('userId', usuario.id);

        if (usuario.active === 'false') {
          Cookies.set('firstLogin', 'true');
          window.location.href = `/changePass`;
        } else {
          window.location.href = `/listaEmpresas`;
        }
      } else {
        this.setState({ incorrectUser: true });
      }
    } catch (err) {
      this.setState({ incorrectUser: true });
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      incorrectUser: false,
      userName: '',
      userPassword: '',
    };
  }

  render() {
    return (
   
      
       
    
        <div>
           
        <form
          onSubmit={(event) => {
            event.preventDefault();
            const email = this.email.value;
            const password = this.password.value;
            this._logIn(email, password);
          }}
        >
         
          <div className="popup_login_container">
            
            <div className="popup_content_login">
            <NavBar cambiarIdioma={this.cambiarIdioma} />
             
      
              <h1 className="title_login">Log In</h1>
      
              <div className="content_login">
                <p className="error_user_login">
                  {this.state.incorrectUser ? `${i18n.t('incorrectUser')}` : ""}
                </p>
      
                <div className="input_container">
                  <input
                    required
                    type="text"
                    id="email"
                    className="input_box"
                    ref={(email) => (this.email = email)}
                  />
                  <label htmlFor="email" className="label_email_login">
                  {i18n.t('Email')}
                  </label>
                </div>
      
                <div className="input_container">
                  <input
                    required
                    type="password"
                    id="password"
                    className="input_box"
                    ref={(password) => (this.password = password)}
                  />
                  <label htmlFor="password" className="label_password_login">
                    Password
                  </label>
                </div>
              </div>
      
              <button type="submit" className="btn_submit">
                Sign In
              </button>
              <button className="btn_submit"  onClick={(event) => {
                  window.location.href = "/";
                }}>
              {i18n.t('back')}
            </button>
              <p className="support_login">
              <a href="/resetPassword">{i18n.t('forgotPassword')}</a>
               
              </p>
            </div>
          </div>
        </form>
      </div>
    
    );
  }
}

export default  withTranslation()(LogIn);
